module.exports = __webpack_public_path__ + "static/media/cloudy-night-3.bf91ac0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/cloudy-night-3.svg
// module id = 515
// module chunks = 0